import styled from 'styled-components'

export const DescriptionTemplatesHintStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 12px;
  background: var(--t-description-templates-hint-bg);
`

export const Left = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  min-width: 0;
  flex-grow: 1;

  & svg {
    color: var(--t-description-templates-hint-info-icon-color);
  }
`

export const Text = styled.div``

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
`

export const ButtonSelectWrap = styled.div`
  min-width: 166px;
`

export const ButtonCloseWrap = styled.div`
  & button {
    padding: 15px 10px;
  }

  & svg {
    margin: 0;
  }
`
